export const AVAILABLE_LANGUAGES = [
  { label: "🇺🇸 English", locale: "en" },
  { label: "🇪🇸 Español", locale: "es" },
];

export const NAMESPACES = [
  "common",
  "settings",
  "customer",
  "navigation",
  "notifications",
  "integrations",
  "products",
  "auth",
  "chat",
  "paywall",
  "documentCenter",
  "documents",
  "virtualDataRooms",
  "spending",
  "taxDeadlines",
  "tasks",
  "fundraising",
  "notSupported",
  "searchAndReporting",
  "orgChart",
  "workflowTemplates",
  "tools",
  "batchEmail",
  "bulkFup",
  "myCompanies",
];
